import { InfoHelper } from "../helpers/info.helper";
import { NavTabStateComponent } from "./nav-tab-state.component";
import { NavStorageService } from "../../nav-storage/services/nav-storage.service";
import { TranslateDto } from 'src/app/core/models/translate/translate.dto';
import { SnackbarService } from "../components/snackbar/snackbar.service";
import { Router } from '@angular/router';
import { NavigationHelper } from "../helpers/navigation.helper";
import { SendInfoComponentService } from "../../services/local/send-info.component.service";
import { TranslateHelper } from '../helpers/translate.helper';
import { WorkplaceStorageService } from "../../services/local/workplaces-storage.service";
import { UserAdminService } from "../../services/user-admin/user-admin.service";
import { FormGrantDTO } from "../../models/user/user-config-access.dto";
import { GlobalInjector } from "../../utils/global.injector";

export class DefaultConfigComponent<T> extends NavTabStateComponent<T> {
    flagCard: boolean = true;
    infoOrganization: string;
    infoBranchOffice: string;
    infoProfile: string;
    userId: string;
    username: string;
    fullName: string;
    logoOrg: string;
    photo: string;
    orgId: number;
    branchId: number;
    profileId: number;
    menuUnitId: number;
    menuSpecialityId: number;
    objNav: any;
    changeTraduction: boolean;
    isNOM024Enabled: boolean;
    formId: number;

    listTraduction: TranslateDto = {} as TranslateDto;
    grantList: FormGrantDTO[] = [];
    cveLanguage: string = "";

    constructor(
        protected snackBarService: SnackbarService,
        readonly infoHelper : InfoHelper,
        protected override navStorageService: NavStorageService,
        protected navRouter: Router, obj: any, readonly sendInfo: SendInfoComponentService,
        readonly userAdminService?: UserAdminService
        ) {
            super(navStorageService, obj, navRouter);
            this.objNav = obj;
    }


    loadInfo(){
        this.infoOrganization = this.infoHelper.getOrganization();
        this.infoBranchOffice = this.infoHelper.getBranchOffice();
        this.infoProfile = this.infoHelper.getProfile();
        this.userId = this.infoHelper.getIdUser();
        this.username = this.infoHelper.getUsername();
        this.orgId = this.infoHelper.getIdOrg();
        this.branchId = this.infoHelper.getIdBranch();
        this.profileId = this.infoHelper.getIdProfile();
        this.logoOrg = this.infoHelper.getLogoOrganization();
        this.fullName = this.infoHelper.getFullname();
        this.photo = this.infoHelper.getPhotoProfileUser();
        this.isNOM024Enabled = this.infoHelper.getEnableNOM024();
        this.menuUnitId = this.infoHelper.getUnitId();
        this.menuSpecialityId = this.infoHelper.getSpecialityIdByData();

    }

    openInfoMsg(msg: string) {
        this.snackBarService.openSnackBarInfo(msg);
    }
    openDangerMsg(msg: string) {
        this.snackBarService.openSnackBarDanger(msg);
    }
    openWarningMsg(msg: string) {
        this.snackBarService.openSnackBarWarning(msg);
    }
    openSuccessMsg(msg: string, time?: number) {
        this.snackBarService.openSnackBarCheck(msg, time);
    }
    openCautionMsg(msg: string) {
        this.snackBarService.openSnackBarCaution(msg);
    }

    openInfoMsgTranslate(cveLanguage: string, cve = "msg") {
        let msg = this.listTraduction[cve]?.get(cveLanguage) || cve+"."+cveLanguage;
        this.snackBarService.openSnackBarInfo(msg);
    }
    openDangerTranslate(cveLanguage: string, cve = "msg") {
        let msg = this.listTraduction[cve]?.get(cveLanguage) || cve+"."+cveLanguage;
        this.snackBarService.openSnackBarDanger(msg);
    }
    openWarningTranslate(cveLanguage: string, cve = "msg") {
        let msg = this.listTraduction[cve]?.get(cveLanguage) || cve+"."+cveLanguage;
        this.snackBarService.openSnackBarWarning(msg);
    }
    openSuccessTranslate(cveLanguage: string, cve = "msg") {
        let msg = this.listTraduction[cve]?.get(cveLanguage) || cve+"."+cveLanguage;
        this.snackBarService.openSnackBarCheck(msg);
    }
    openCautionTranslate(cveLanguage: string, cve = "msg") {
        let msg = this.listTraduction[cve]?.get(cveLanguage) || cve+"."+cveLanguage;
        this.snackBarService.openSnackBarCaution(msg);
    }

    override getViewState() {

    }
    override setViewState() {

    }
    override newState(model: T): T {
        return model;
    }
    override getFormControl() {

    }
    override setFormControl(aux: any) {

    }

    async onListenTranslate(url: string) {
        await this.forceGetTranslate(url);
        this.sendInfo.sendObjectAction.subscribe(data => {
            if (data.isExecuted && data.key === "traduction") {
                this.cveLanguage = data.value;
                this.listTraduction = TranslateHelper.getTranslation(url, true);
                this.changeTraduction = true;
            }
        });
    }

    async loadGrantsByFormId(url: string){
        this.grantList = WorkplaceStorageService.getOverAccesGrants();
    }

    validGrant(grantName: string): boolean{
        if(this.grantList == null){
            return false;
        }

        const grandFound= this.grantList.find((grant) => grant.grantName === grantName);
        if (grandFound){
            return true;
        }
        return false;
    }

    closeScreen(){
        this.navStorageService.removeItem(this.objNav.tag);
        this.navRouter.navigate([NavigationHelper.getUrlBack(this.objNav.url)]);
    }

    // si no encuentra traduccion la forza a descargarla de nuevo
    async forceGetTranslate(url: string) {
        try{
            this.listTraduction = TranslateHelper.getTranslation(url, true);
            if ( !this.listTraduction || !this.listTraduction.ph || this.listTraduction.ph.size === 0) {
                let translateHelperServ: TranslateHelper =  GlobalInjector.get(TranslateHelper); 
                await translateHelperServ.getTranslationTags(url, false);
                await translateHelperServ.getFormTranslateByUrl(url,"", false);
                this.listTraduction = TranslateHelper.getTranslation(url, true);
            }
            this.cveLanguage = WorkplaceStorageService.getLanguageCve();
            this.changeTraduction = true;
        } catch (error) {
            this.openCautionMsg("Error al obtener el servicio traducciones");
        }
    }

}
